const initCardFormValidation = (root = document) => {
  // Block Card form validation
  const blockForm = root.querySelector("form[action*='block_patron_card']");
  if (blockForm) {
    blockForm.addEventListener("submit", (e) => {
      const reasonField = blockForm.querySelector("#card_remarks_attributes_0_remark_text");
      if (reasonField && reasonField.value.trim() === "") {
        e.preventDefault();
        alert("Reasons cannot be empty.");
        reasonField.focus();
      }
    });
  }

  // Card Replacement form validation
  const replaceForm = root.querySelector("form[action*='replace_patron_card']");
  if (replaceForm) {
    replaceForm.addEventListener("submit", (e) => {
      const newCardField = replaceForm.querySelector("#card_new_card_no");
      const reasonField = replaceForm.querySelector("#card_remarks_attributes_0_remark_text");

      if (newCardField && newCardField.value.trim() === "") {
        e.preventDefault();
        alert("Replacement Card Number cannot be empty.");
        newCardField.focus();
        return;
      }

      if (reasonField && reasonField.value.trim() === "") {
        e.preventDefault();
        alert("Reasons cannot be empty.");
        reasonField.focus();
      }
    });
  }
};

// Call on page load and Turbo visit
document.addEventListener("turbo:load", () => initCardFormValidation());